module.exports = __webpack_public_path__ + "img/sm.71843734.svg";